import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
import OrderShow from "./OrderShow";
import Navbar from "./Navbar";
// import { Navigate } from "react-router-dom";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

function Orders() {
  const [myOrders, setMyOrders] = useState(null);

  useEffect(() => {
    axios
      .get(SERVER_URL+"/api/myorders", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("userTokenTime")).token,
        },
      })
      .then((res) => {
        setTimeout(() => {
          console.log(res.data);
          setMyOrders((prev) => res.data);
        }, 100);
        console.log(myOrders);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const { myOrders } = useSelector((state) => state.cartReducer);
  // if (!localStorage.getItem("userTokenTime")) return <Navigate to="/signin" />;
  return (
    <>
      <Navbar />
      <div className="Orders">
        <div className="Head">
          <h1>My Orders</h1>
          <h4>View all Your pending orders and delivered Orders.</h4>
        </div>
        <hr className="line1" />
        <div className="items">
          <div className="item-row">
            {myOrders &&
              myOrders.map((order) => (
                <div className="orderone">
                  <div
                    className="ORDER order__header"
                    style={{
                      width: "55vw",
                      boxShadow: " rgb(0 0 0 / 20%) 0px 1px 2px 0px",
                      padding: "15px 20px",
                      backgroundColor: "#DDDDDD",
                      fontSize: "1.1rem",
                      fontWeight: "500",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span className="order__no">
                      Order Number: {order.transactionId}{" "}
                    </span>
                    <span>Order Date: {order.orderDateAndTime} </span>
                    <span>Order Status: {order.status} </span>

                    {/* <span>Order Total: ₹ {order.totalPrice}</span> */}
                  </div>
                  {order.orderItems.map((item) => (
                    <OrderShow
                      key={item._id}
                      item={item}
                      className="orderItem"
                    />
                  ))}
                  <hr />
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Orders;
